import {connect} from "react-redux";
import LeadAddressPendingList from "./PendingList";
import {bindActionCreators} from "redux";
import {addressApprovalPendingListRequest} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    addressApprovalPendingListResponse:state.Lead.addressApprovalPendingListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addressApprovalPendingListRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadAddressPendingList);
